import React from 'react';
import { variantClass } from '../../../../util/variant';

const LockedBanner = ({ show, variant, message }) => {
    if (!show) return null;

    return (
        <div
            className={`docfirst__locked ${variantClass(variant)}`.trim()}
            role="status"
            data-testid="business-v2-locked-banner"
        >
            <div className="docfirst__locked-title">This application is locked</div>
            <div className="docfirst__locked-body">
                {message
                    || 'The account has been created, so these details can no longer be edited here. Contact compliance if something needs to change.'}
            </div>
        </div>
    );
};

export default LockedBanner;

